import React, { useState } from "react";
import { Modal, Button, Form, Image } from "react-bootstrap";

interface Props {
  onSubmit: (formData: FormData) => void;
}

const NewCustomAdModal: React.FC<Props> = ({ onSubmit }) => {
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);

  const onClose = () => setShowModal(false);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = () => {
    if (!imageFile) {
      alert("Please select an image");
      return;
    }

    const formData = new FormData();
    formData.append("contentLocation", imageFile);

    onSubmit(formData);
    onClose();
  };

  return (<>
    <Button variant="success" onClick={() => setShowModal(true)}>
      + Add New Ad
     </Button>
    <Modal show={showModal} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add New Custom Ad</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>

          <Form.Group className="mb-3">
            <Form.Label>Upload Image</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={handleImageChange}
            />
          </Form.Group>

          {imagePreview && (
            <div className="text-center mb-3">
              <Image
                src={imagePreview}
                thumbnail
                height={120}
                style={{ objectFit: "cover" }}
              />
            </div>
          )}

        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="primary" onClick={handleSubmit}>
          Upload Ad
        </Button>
      </Modal.Footer>
    </Modal>
  </>);
};

export default NewCustomAdModal;
